var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7782,
    cy: 15.0057,
    r: 14.5057,
    fill: "#ECE7FC",
    stroke: "#D8CFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0518 13.4477L15.1342 9.48043C14.7599 9.26428 14.335 9.15104 13.9028 9.15223C13.4706 9.15342 13.0463 9.26898 12.6732 9.48718C12.3001 9.70539 11.9913 10.0185 11.7784 10.3946C11.5654 10.7707 11.4558 11.1965 11.4606 11.6287V19.5918C11.4606 20.2414 11.7186 20.8643 12.1779 21.3236C12.6372 21.7829 13.2601 22.0409 13.9097 22.0409C14.3397 22.0402 14.7619 21.9266 15.1342 21.7115L22.0518 17.7443C22.4235 17.5292 22.7321 17.2201 22.9466 16.848C23.1612 16.476 23.2741 16.0541 23.2741 15.6246C23.2741 15.1951 23.1612 14.7732 22.9466 14.4012C22.7321 14.0292 22.4235 13.7201 22.0518 13.5049V13.4477ZM21.3357 16.4481L14.4181 20.4726C14.2631 20.5605 14.0879 20.6067 13.9097 20.6067C13.7315 20.6067 13.5563 20.5605 13.4012 20.4726C13.2466 20.3834 13.1183 20.255 13.029 20.1004C12.9398 19.9458 12.8928 19.7704 12.8928 19.5918V11.6001C12.8928 11.4216 12.9398 11.2462 13.029 11.0916C13.1183 10.9369 13.2466 10.8086 13.4012 10.7193C13.5569 10.6328 13.7316 10.586 13.9097 10.5832C14.0877 10.5869 14.2621 10.6336 14.4181 10.7193L21.3357 14.7152C21.4904 14.8044 21.6188 14.9328 21.7081 15.0874C21.7974 15.242 21.8444 15.4174 21.8444 15.596C21.8444 15.7745 21.7974 15.9499 21.7081 16.1046C21.6188 16.2592 21.4904 16.3876 21.3357 16.4768V16.4481Z",
    fill: "#7F56D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.db279443090a2cf2e5cff58b6a413a9c.svg";
export { ForwardRef as ReactComponent };